import { render } from "./Mobile.vue?vue&type=template&id=5fff18bc"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import "./Mobile.vue?vue&type=style&index=0&id=5fff18bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__